"use client";
import React, { useMemo } from "react";
import Head from "next/head";
import { useAppProps } from "~/app/_apps/AppPropsContext";
import AdminPageShopTab from "./AdminPageShopTab";
import { TurnrGrid } from "~/components/TurnrGrid.jsx";
import { TurnrTabs } from "~/components/tabs/TurnrTabs.jsx";
import { useQueryState } from "rylak-common/src/hooks/useQueryState.jsx";
import { TurnrCard } from "~/components/card/TurnrCard.jsx";
import AdminPageGroupCard from "./AdminPageGroupTab";
import { QUERY_AND_SESSION_KEYS } from "return-portal/src/constants";
import AdminPageUsersTab from "~/app/(pages)/settings/admin/AdminPageUsersTab";
import { ADMIN_PAGE_TABS } from "~/constants";

export default function SettingsAdminPage() {
    const { appProps } = useAppProps();

    const [selectedTab, setSelectedTab] = useQueryState({ key: QUERY_AND_SESSION_KEYS.PAGE_TAB, defaultValue: ADMIN_PAGE_TABS.SHOP });

    const tabs = useMemo(() => {
        const array = [];

        array.push({
            value: ADMIN_PAGE_TABS.SHOP,
            label: "Shops",
            content: <AdminPageShopTab appProps={appProps} />,
        });

        array.push({
            value: ADMIN_PAGE_TABS.SHOP_GROUP,
            label: "Shop Groups",
            content: <AdminPageGroupCard appProps={appProps} />,
        });

        array.push({
            value: ADMIN_PAGE_TABS.USERS,
            label: "Users",
            content: <AdminPageUsersTab appProps={appProps} />,
        });

        return array;
    }, [appProps, selectedTab]);

    return (
        <>
            <Head>
                <title>Admin settings</title>
            </Head>
            <TurnrCard>
                <TurnrGrid container spacing={2}>
                    <TurnrGrid item xs={12}>
                        <TurnrTabs value={selectedTab} onlyRenderSelected onChange={setSelectedTab} tabs={tabs} />
                    </TurnrGrid>
                </TurnrGrid>
            </TurnrCard>
        </>
    );
}
